module.exports = __webpack_public_path__ + "default-banner.2d607dc6621f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default-banner.png
// module id = 462
// module chunks = 10